import { render, staticRenderFns } from "./RecommendationPackage.vue?vue&type=template&id=47830202"
import script from "./RecommendationPackage.vue?vue&type=script&lang=js"
export * from "./RecommendationPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports